import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Swal from 'sweetalert2';


export const updateTestimonial = createAsyncThunk(
  'testimonials/updateTestimonial',
  async ({ id, updatedData }, { rejectWithValue }) => {
    const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');
    
        if (role !== 'superadmin') {
          Swal.fire({
            icon: 'error',
            title: 'Access Denied',
            text: 'Only Superadmin can accept appointments',
          });
          return rejectWithValue('Unauthorized');
        }

    try {
      const response = await axios.put(
        `https://api.thevisaman.in/api/testimonials/${id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      return response.data.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Update failed',
      });
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const testimonialUpdateSlice = createSlice({
  name: 'testimonialUpdate',
  initialState: {
    updatedTestimonial: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearUpdateState: (state) => {
      state.updatedTestimonial = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.updatedTestimonial = action.payload;
      })
      .addCase(updateTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUpdateState } = testimonialUpdateSlice.actions;
export default testimonialUpdateSlice.reducer;
